import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { triggerPublicEvent, PublicEvents } from '@project/shared/utils/events/js/events';

/**
 * product-finder-teaser module implementation.
 *
 * @author Heiko Frosch <heiko.frosch@namics.com>
 */
const classes = {
	materialSelect: 'js-m-product-finder-teaser__select-material',
	countrySelect: 'js-m-product-finder-teaser__select-marketswitch',
	link: 'js-m-product-finder-teaser__link',
};

@createModule('ProductFinderTeaser')
export class ProductFinderTeaser extends TerrificSpec {
	$ctx: JQuery;
	data: any;
	$form: JQuery;
	$link: JQuery;
	$paramValues: any;

	/**
	 * start method, called on terrific bootstap
	 *
	 * @param {Object} resolve  function to call at the end of component start
	 * @returns {void}
	 */
	start(resolve: Function) {
		this.$ctx = $(this._ctx);
		this.data = this.$ctx.data();
		this.$form = $('.js-m-product-finder-teaser__form', this.$ctx);
		this.$link = $(`.${classes.link}`, this._ctx);

		this.$ctx.on('FilterTwoLevelMultiCheckboxChanged', this.adjustLinkUrl.bind(this));
		this.$ctx.find(`.${classes.link}`).on("click", this.onButtonSubmitTeaser.bind(this));

		this.adjustLinkUrl();

		resolve();
	}

	adjustLinkUrl() {
		const separator = this.data.filterseperator || ':';
		const sortingParam = this.data.sortingparam ? separator + this.data.sortingparam : '';
		const countryParam = separator + this.data.countryparam + separator + this.data.marketparam;

		const serializedData = this.$form
			.serializeArray()
			.filter((e) => {
				return e.value !== '';
			})
			.map((e) => {
				return encodeURIComponent(e.value);
			});
		let materialAndIndustryParams = '';

		if (serializedData.length) {
			materialAndIndustryParams = separator + serializedData.join(separator);
		}

		const allParams = sortingParam + countryParam + materialAndIndustryParams;
		const newLinkUrl = this.data.baseurl + '/?' + this.data.queryparam + '=' + allParams;

		this.$paramValues = allParams;
		this.$link.attr('href', newLinkUrl);
	}

	onButtonSubmitTeaser() {
		localStorage.setItem("productFinderTeaserQueryParams", JSON.stringify(this.$paramValues));
	}

	/**
	 * stop method, called on terrific stop
	 *
	 * @returns {void}
	 */
	stop() {}
}
